import React from "react";
import Header from "./Header";
import FiledConfig from "../filed/config/FiledConfig";

export default function LayoutFiledConfig() {
  return (
    <>
      <Header />
      <FiledConfig />
    </>
  );
}
